<div class="onglet-container">

  <!-- Header : titre + navigation -->
  <div class="onglet-header">
    @if (title()) {
      <h2 class="onglet-title">{{ title() }}</h2>
    }

    <div class="onglet-nav-wrapper">
      <nav class="onglet-nav" role="tablist">

        @for (link of ongletLinks(); track link.link) {
            <a
            role="tab"
            class="onglet-link"
            [routerLink]="link.link"
            routerLinkActive="onglet-active"
            [routerLinkActiveOptions]="link.link === '' ? { exact: true } : { exact: false }"
            [attr.aria-selected]="isActive(link)"
            (click)="onClickMenu.emit()"
          >
            {{ link.text }}
          </a>
        }

      </nav>
    </div>
  </div>

  <!-- Contenu de l'onglet actif -->
  <div class="onglet-content">
    <router-outlet />
  </div>

</div>